import common from '../common';

export default {
  jpath: ['spectra', 'isotherm'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
};
